import jwtDecode from "jwt-decode"
import { useMemo } from "react"
import type { IHasOwner, JwtToken } from "../redux"
import { useJwtToken } from "./useJwtToken"

export function useIsOwner(data: IHasOwner): boolean {
  const { token } = useJwtToken()

  const isOwner: boolean = useMemo<boolean>(() => {
    if (!token) return false
    const { primarysid }: JwtToken = jwtDecode(token)
    return primarysid === data.profileId
  }, [token, data.profileId])

  return isOwner
}
